import { useSite } from "../siteContext";
import { useLang } from "../i18n";

export const Marquee = () => {
  const settings = useSite();
  const { lang } = useLang();
  const ITEMS =
    lang === "en" && settings.marquee_phrases_en?.length
      ? settings.marquee_phrases_en
      : settings.marquee_phrases || [];
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee-section" className="relative py-10 border-y border-luxury-border overflow-hidden bg-luxury-dark">
      <div
        className="flex w-max animate-marquee"
        dir="ltr"
        style={{ animationDirection: lang === "ar" ? "normal" : "reverse" }}
      >
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center" dir={lang === "ar" ? "rtl" : "ltr"}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-serif text-3xl md:text-5xl text-luxury-bone/15 px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="text-luxury-gold/40 text-xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
